import { z } from 'zod';

import { ArtifactFile } from '../../types';

const FILE_DRAG_ID_PREFIX = 'file:';
const ARTIFACT_DROP_ID_PREFIX = 'artifact:';

const artifactFileSchema = z.object({
  sourceId: z.number(),
  path: z.string(),
  ref: z.string(),
}) satisfies z.ZodType<ArtifactFile>;

export function encodeFileDragId(file: ArtifactFile): string {
  return `${FILE_DRAG_ID_PREFIX}${JSON.stringify(file)}`;
}

export function decodeFileDragId(
  id: string | number
): ArtifactFile | undefined {
  if (typeof id !== 'string' || !id.startsWith(FILE_DRAG_ID_PREFIX)) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(id.slice(FILE_DRAG_ID_PREFIX.length));
    const result = artifactFileSchema.safeParse(parsed);
    return result.success ? result.data : undefined;
  } catch {
    return undefined;
  }
}

export function encodeArtifactDropId(index: number): string {
  return `${ARTIFACT_DROP_ID_PREFIX}${index}`;
}

export function decodeArtifactDropId(id: string | number): number | undefined {
  if (typeof id !== 'string' || !id.startsWith(ARTIFACT_DROP_ID_PREFIX)) {
    return undefined;
  }

  const index = Number(id.slice(ARTIFACT_DROP_ID_PREFIX.length));
  return Number.isInteger(index) ? index : undefined;
}
